import React, { FC, ReactNode } from 'react';
import { Tooltip, TooltipProps } from '@material-ui/core';
import { useStyles } from './SpeechBubbleTooltipStyled';

export type SpeechBubbleTooltipProps = TooltipProps & {
  children: ReactNode;
};

const SpeechBubbleTooltip: FC<SpeechBubbleTooltipProps> = ({ children, ...tooltipProps }) => {
  const classes = useStyles();
  return (
    <Tooltip
      arrow
      style={{ cursor: 'pointer' }}
      open={tooltipProps.open}
      {...tooltipProps}
      classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}
    >
      <span>{children}</span>
    </Tooltip>
  );
};

export default SpeechBubbleTooltip;
